import React from "react";
import { ButtonGroup, Button } from "@mui/material";

interface ViewModeToggleProps {
  viewMode: "edit" | "view" | "results";
  setViewMode: (mode: "edit" | "view" | "results") => void;
  sx?: any;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  setViewMode,
  sx,
}) => {
  return (
    <ButtonGroup variant="outlined" aria-label="view mode" sx={sx}>
      <Button
        variant={viewMode === "edit" ? "buttonGroupSelected" : "buttonGroup"}
        onClick={() => setViewMode("edit")}
        sx={{ width: "100%" }}
      >
        Edit
      </Button>
      <Button
        variant={viewMode === "view" ? "buttonGroupSelected" : "buttonGroup"}
        onClick={() => setViewMode("view")}
        sx={{ width: "100%" }}
      >
        View
      </Button>
      <Button
        variant={viewMode === "results" ? "buttonGroupSelected" : "buttonGroup"}
        onClick={() => setViewMode("results")}
        sx={{ width: "100%" }}
      >
        Results
      </Button>
    </ButtonGroup>
  );
};

export default ViewModeToggle;
